<div class="container-fluid common-pages-banner">
    <div class="container">
        <div class="tg-theme-heading">
            <h1 class="h1tags">Crystal Tower</h1>
        </div>
    </div>
</div>

<section class="learning-outer">
    <div class="container">
        <div class="row">
            <div class="col-md-8 col-sm-12">
                <div id="carouselExampleIndicators" class="carousel slide " data-ride="carousel">
                    <ol class="carousel-indicators">
                        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                        <!--  <li data-target="#carouselExampleIndicators" data-slide-to="2"></li> -->
                    </ol>
                    <div class="carousel-inner min-ouitewr">
                        <div class="carousel-item active">
                            <img class="d-block w-100" src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/img-contact/slider-i.jpg" alt="First slide">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/img-contact/sldiuer-w.jpg" alt="Second slide">
                        </div>
                        <!--  <div class="carousel-item">
      <img class="d-block w-100" src="..." alt="Third slide">
    </div> -->
                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
                <section class="inner-text-lissting">
                    <div class="container">
                        <div class="learning-rtext">
                            <h2>Features:</h2>

                        </div>
                        <div class="row">
                            <div class="col-md-6 col-sm-12">
                                <ul>

                                    <li> <span class="ouetyr"><i class="fas fa-arrow-right"></i></span>High-Speed lift</li>
                                    <li> <span class="ouetyr"><i class="fas fa-arrow-right"></i></span>Ample Parking</li>

                                    <li> <span class="ouetyr"><i class="fas fa-arrow-right"></i></span>Best location in Alwar city near Nangli Circle</li>
                                    <li> <span class="ouetyr"><i class="fas fa-arrow-right"></i></span>Instant registration & possession</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <ul>

                                    <li> <span class="ouetyr"><i class="fas fa-arrow-right"></i></span>Benefits</li>
                                    <li> <span class="ouetyr"><i class="fas fa-arrow-right"></i></span>Tight Security</li>
                                    <li> <span class="ouetyr"><i class="fas fa-arrow-right"></i></span>Shops, office and apartment available </li>
                                    <li> <span class="ouetyr"><i class="fas fa-arrow-right"></i></span>Assured Rental Income from Day-1</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <div class=" col-md-4 col-sm-12">
                <div class="right-textt">
                    <div class="inner-text-inmg">
                        <h1 class="text-min">crystal tower</h1>
                        <p>location: nangli Circle Alwar</p>
                        <h1>Rental guarantee right from day one</h1>
                        <h3>₹13.77 Lakh Starting Price</h3>
                        <ul>
                            <li> <span class="ouetyr"><i class="fas fa-arrow-right"></i></span>Limited offices/shops left</li>
                            <li> <span class="ouetyr"><i class="fas fa-arrow-right"></i></span>Best location in Alwar city near Nangli Circle</li>
                            <li> <span class="ouetyr"><i class="fas fa-arrow-right"></i></span>Instant registration and immediate possession</li>
                            <li> <span class="ouetyr"><i class="fas fa-arrow-right"></i></span>No Hidden charges</li>
                        </ul>
                    </div>
                    <div class="buttron-iiunner" style="display: none">
                        <button class="btn btn-danger" data-target="#form_contc">Get a call back</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>



<div class="container-fluid paddEqual bgGray" style="margin-top: 0px !important">
    <div class="container">
        <div class="row">
            <div class="col-md-3 col-12 mp0" style="display: none">
                <div class="row rowLeftM">
                    <div class="col-12 pd-0 usersformms">
                        <div class="row marginZero common-leftbar">
                            <div class="col-12">
                                <div class="col-12 usersHeader">
                                    <h4 class="card-title">Email Us At:</h4>
                                </div>
                                <p>Sales/General Enquires:</p>
                                <a href="mailto:sales@propira.com">sales@propira.com</a>
                                <div class="col-12 usersHeader">
                                    <h4 class="card-title">Call Us At:</h4>
                                </div>
                                <p>Sales/General Enquires:</p>
                                <a href="tel:+919870260930">+91 9870 260 930</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-12">
                <div class="row rowLeftM" id="form_contc">
                    <div class="col-12 pd-0 usersformms">
                        <div class="row marginZero">
                            <div class="col-12">
                                <div class="col-12 usersHeader">
                                    <h4 class="card-title">Contact Us</h4>
                                </div>
                                <form class="col-12 pd-0" [formGroup]="contact" [ngClass]="{'white-layer':contactLoader}" (ngSubmit)="contactEnd()" style="position: relative;">
                                    <div class="alert alert-danger alert-dismissible fade show" *ngIf="contactErrorMsg">
                                        <strong>Error!</strong> {{contactErrorMsg}}.
                                        <button type="button" style="background: none;" class="close" data-dismiss="alert">&times;</button>
                                    </div>
                                    <div class="alert alert-success alert-dismissible fade show" *ngIf="contactSuccessMsg">
                                        <strong>Success!</strong> {{contactSuccessMsg}}.
                                        <button type="button" style="background: none;" class="close" data-dismiss="alert">&times;</button>
                                    </div>
                                    <div class="form-group">
                                        <label>Name</label>
                                        <input type="text" class="form-control" required formControlName="name" placeholder="Enter Name" (keypress)="validateAlpha($event)">
                                        <div class="error-msg" *ngIf="contactControl.name.touched && contactControl.name.errors">
                                            <div style="font-size: 12px">Enter name</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Email-Id</label>
                                        <input type="email" class="form-control" required formControlName="email" placeholder="Enter Email Id">
                                        <div class="error-msg" *ngIf="contactControl.email.touched && contactControl.email.errors">
                                            <div style="font-size: 12px">Enter valid email id</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Phone Number</label>
                                        <input type="tel" class="form-control" required formControlName="phone" placeholder="Enter Phone Number" (keypress)="numberOnly($event,10)">
                                        <div class="error-msg" *ngIf="contactControl.phone.touched && contactControl.phone.errors">
                                            <div style="font-size: 12px">Enter valid phone number</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>State</label>
                                        <select class="form-control" formControlName="state_id" required (change)="getCityList($event.target.value)">
                                            <option value="">Please select state</option>
                                            <option *ngFor="let state of stateList" value="{{state.id}}">{{state.name | titlecase}}</option>
                                        </select>
                                        <div class="error-msg" *ngIf="contactControl.state_id.touched && contactControl.state_id.errors">
                                            <div style="font-size: 12px">Select state name</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>City</label>
                                        <select class="form-control" formControlName="city_id" required>
                                            <option value="">Please Select City</option> 
                                            <option *ngFor="let city of cityList" value="{{city.id}}">{{city.name | titlecase}}</option>
                                        </select>
                                        <div class="error-msg" *ngIf="contactControl.city_id.touched && contactControl.city_id.errors">
                                            <div style="font-size: 12px">Select city name</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Message</label>
                                        <textarea class="form-control" required formControlName="message" placeholder="Enter Message"></textarea>
                                        <div class="error-msg" *ngIf="contactControl.message.touched && contactControl.message.errors">
                                            <div style="font-size: 12px">Enter message</div>
                                        </div>
                                    </div>
                                    <!-- <input  class="form-control" type="checkbox" formControlName="terms"  id="terms" required style="margin-right: 10px;display: inline;height:14px;width: 2%;">I Agree Terms & Coditions
                                    <br><br>
                                    <div class="error-msg" *ngIf="contactControl.terms.touched && contactControl.terms.errors">
                                    <div style="font-size: 12px">Please check the box for further proceed </div>
                                    </div> -->
                                    <div class="form-group">
                                        <button class="btn btn-danger" type="submit">Submit <div class="box" *ngIf="contactLoader"><div class="loader-13"></div>
                                        </div></button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>